import { Modal } from '@mantine/core';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AddCompanySiteFormFields } from './components';
import { AddCompanySiteFormSchemaType, useAddCompanySiteForm } from './hooks';

export type AddCompanySiteModalPropsType = {
  opened: boolean;
  onClose: () => void;
  onSubmit: (data: AddCompanySiteFormSchemaType) => Promise<void>;
  companyName: string;
};

export const AddCompanySiteModal: React.FC<AddCompanySiteModalPropsType> = ({
  opened,
  onClose,
  onSubmit,
  companyName,
}) => {
  const { t } = useTranslation('companyDetailsGeneral');
  const form = useAddCompanySiteForm();

  const handleClose = (): void => {
    form.reset();
    onClose();
  };

  const handleSubmit = async (
    data: AddCompanySiteFormSchemaType
  ): Promise<void> => {
    await onSubmit(data);
    handleClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={t('COMPANY_SITES.ADD_SITE_MODAL.TITLE', { companyName })}
      size="xl"
      closeOnClickOutside={false}
    >
      <FormProvider {...form}>
        <form
          onSubmit={form.handleSubmit(handleSubmit)}
          data-testid="add-company-site-form"
        >
          <AddCompanySiteFormFields onClose={handleClose} />
        </form>
      </FormProvider>
    </Modal>
  );
};
